import React, { useEffect, useState } from "react";
import {
  StyledSectionHeaderComponent,
  StyledListContainer,
  StyledListSection,
} from "../utils/common-styles";
import { Col, Row } from "react-bootstrap";
import { useHttp } from "../hooks/use-http";
import { ArticleItemDetail } from "../components/Articles/ArticleItemDetail";
import { ArticleItemSideBar } from "../components/Sidebar/Articles/ArticleItemSideBar";
import { Loading } from "../components/Extra/Loading";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../utils/utils";

export const AboutTheFriendsPage = (props) => {
  const id = 1;

  const [article, setArticle] = useState({});
  const [otherArticles, setOtherArticles] = useState([]);

  const { isLoading, error, sendRequest: getContent } = useHttp();

  useEffect(() => {
    const parseContent = (data) => {
      let article = data?.payload?.article;
      let otherArticles = data?.payload?.other;
      setArticle((prevState) => {
        return { ...prevState, ...article };
      });

      setOtherArticles((prevState) => {
        return otherArticles;
      });
    };

    let url = `/articles/item/${id}/detail`;
    getContent({ url }, parseContent);
  }, [id, getContent]);

  return (
    <>
      <Helmet>
        <title>About the Friends - The Friends of Queen's Wood</title>
        <meta name="description" content="The Friends of Queen's Wood is a group of volunteers that help look after the wood" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="About the Friends - The Friends of Queen's Wood" />
        <meta property="og:description" content="The Friends of Queen's Wood is a group of volunteers that help look after the wood" />
        <meta property="og:url" content={`${window.location.origin}`} />
        <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
        <meta name="twitter:title" content="The Friends of Queen\'s Wood" />
        <meta name="twitter:description" content="The Friends of Queen\'s Wood is a group of volunteers that help look after the wood" />
        <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
      </Helmet>
      <StyledSectionHeaderComponent title="About the Friends" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              {isLoading && <Loading />}
              {!isLoading && <ArticleItemDetail post={article} />}
              {error && <p style={{ color: "red" }}>{error}</p>}
            </Col>
            <Col xs={12} md={3}>
              {!isLoading && <ArticleItemSideBar post={article} other={otherArticles} />}
            </Col>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
